<template>
  <div class="main-wrapper text-primary text-size-m">
    <HeaderMain id="app-header" />
    <router-view />
    <Loader />
    <Alert />
  </div>
</template>

<script>
import HeaderMain from "@/components/app/HeaderMain.vue";
import Loader from "@/components/shared/loaders/CommonLoader.vue";
import Alert from "@/components/shared/alert/CommonAlert.vue";
import { captureException } from "@sentry/vue";
import { addShortLog } from "@/api/general";

export default {
  name: "App",
  components: {
    HeaderMain,
    Loader,
    Alert,
  },
  mounted() {
    if(this.$cookie.getCookie("mb_red")=="control"){
      this.$logAnalyticEvent("viewed_experiment", {
      experiment_id: "mybank_red_redesign",
      variation_id: "control",
    });
    }
    this.logEntry();
    if (!this.$cookie.getCookie("test.user.group")) {
      captureException(new Error("No cookie: test.user.group"));
      this.$cookie.setCookie("test.user.group", "15");
    }
  },
  methods: {
    logEntry() {
      const ma_ver = this.$cookie.getCookie("ma_ver");
      const mobapp_version = this.$cookie.getCookie("mobapp_version");
      const inRedesignLogId = "NotInRedesign";
      const body = {
        LogType: "INFO",
        PathUrl: window.location.pathname,
        Data: `${JSON.stringify({
          path: this.$route.path,
          href: window.location.href,
          ma_ver,
          mobapp_version,
          inRedesignLogId,
        })}`,
        LogId: inRedesignLogId,
      };
      if(this.$cookie.getCookie("mb_red")=="control"){
        addShortLog(body);
      }
    },
  },
};
</script>

<style lang="scss">
@import "./assets/styles/icons.scss";
@import "./assets/styles/global.scss";

#app-header {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  width: 100vw;
  overflow: hidden;
  z-index: 5;
}
</style>

<style lang="postcss">
@import "./styles/default.pcss";

#app {
  font-family: Roboto-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #4a4a4a;
  background: #f0f0f0;
  line-height: 1.2;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

* {
  touch-action: manipulation;
}

*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  line-height: 1.5;
  color: #212529;
  background-color: #f0f0f0;
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
}
</style>
